import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, Paper, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

/** Shown instead of a silent redirect when the signed-in user may not open a page. */
const NoAccess: React.FC = () => {
    const navigate = useNavigate();
    return (
        <Box sx={{ p: 3, display: 'flex', justifyContent: 'center' }}>
            <Paper sx={{ p: 4, maxWidth: 480, textAlign: 'center' }} data-testid="no-access" data-help-page="common.noAccess.page">
                <LockOutlinedIcon color="disabled" sx={{ fontSize: 48 }} />
                <Typography variant="h6" gutterBottom>You don't have access to this page</Typography>
                <Typography color="text.secondary" sx={{ mb: 2 }}>
                    Your role doesn't include this area. If you think you need it, ask your administrator.
                </Typography>
                <Button variant="contained" onClick={() => navigate('/')} data-help="common.noAccess.home">Go to home</Button>
            </Paper>
        </Box>
    );
};

export default NoAccess;
